import React from 'react';

import {MainHeader} from 'presentation/components/MainHeader';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {translations} from 'presentation/translations-new';
import {useConsultRefund} from '../../hooks';
import {InitialStep, ListStep} from '../ConsultRefund/components';

const {title} = translations['pt-br'].privateFlow.consultPreviewRefund;

export function ConsultRefundPreview() {
	const {handleBack, step, handleExitFlow} = useConsultRefund();

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				variant="subRoute"
				title={title}
				handleBack={handleBack}
				handleClose={handleExitFlow}
			/>
			{!step ? <InitialStep variant="preview" /> : <ListStep variant="preview" />}
		</PageWrapperLayout>
	);
}
